import { render, staticRenderFns } from "./enterpriseCAApplyStatus.vue?vue&type=template&id=2bd2fff6&scoped=true"
import script from "./enterpriseCAApplyStatus.vue?vue&type=script&lang=js"
export * from "./enterpriseCAApplyStatus.vue?vue&type=script&lang=js"
import style0 from "./enterpriseCAApplyStatus.vue?vue&type=style&index=0&id=2bd2fff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2fff6",
  null
  
)

export default component.exports